/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(function ($) {
	// if ( $.hasOwnProperty('select2')) {
	$('.wpcf7-select').select2();

	// }
});
